import type { TFunction } from 'i18next';
import type { CognitiveFitness } from '../../model';
import type { AssessmentResultItemDataFragment } from '@/gql/graphql';
import { formatDecimalValue } from '@/utils/common';

const parseSpatialPlanning = (t: TFunction, items: AssessmentResultItemDataFragment[]): CognitiveFitness | null => {
    const item = items.find(i => i.result.__typename === 'SpatialPlanningResult');
    if (!item || item.result.__typename !== 'SpatialPlanningResult') {
        return null;
    }
    const mi = item.moduleInstance;
    const r = item.result;
    if (!mi?.name) {
        return null;
    }

    return {
        name: mi.name ?? '',
        moduleDefinitionIdentifier: mi.moduleDefinitionIdentifier ?? '',
        description: mi.description ?? '',
        result: [
            {
                label: t('traineeReports:performance.cognitiveFitness.scoreLabel'),
                value: t('traineeReports:performance.cognitiveFitness.scoreValue', {
                    value: `${formatDecimalValue(r.accuracy ?? 0)}/100`,
                }),
            },
            {
                label: t('traineeReports:performance.cognitiveFitness.avgResponseTimeMs'),
                value: `${Math.round(r.averageResponseTimeMs)}`,
            },
        ],
    };
};

export default parseSpatialPlanning;
